<div class="gl-page">
  <!-- Back link -->
  <yds-button-back text="Ga terug 'Overzicht boekingsdefinitie'" (back)="goBack()" />

  <!-- Title + page actions -->
  <div class="gl-page__header">
    <h1 class="gl-page__title">Boekingsdefinitie</h1>
    <div class="gl-page__header-actions">
      @if (!isAddMode()) {
        <yds-button (click)="goToBookingGroup()">Boekingsgroep</yds-button>
        <yds-button (click)="goToBookingRule()">Boekingsregel</yds-button>
        <yds-button variant="destructive" (click)="onDelete()">Verwijderen</yds-button>
      }
    </div>
  </div>

  @if (isLoading()) {
    <div class="gl-detail-loading">
      <yds-spinner [label]="'Boekingsdefinitie laden...'" />
    </div>
  } @else {
  <!-- Details card -->
  <yds-card-editable
    #detailsCard
    title="Details"
    [(editing)]="detailsEditing"
    [nextDisabled]="isSaving() || form.invalid"
    [nextLabel]="isAddMode() ? 'Volgende' : 'Opslaan'"
    (cancel)="onDetailsCancel()"
    (next)="onDetailsNext()"
  >
    @if (notFound()) {
      <p class="bde-empty">Er zijn geen details voor boekingsdefinitie gevonden.</p>
    } @else if (detailsEditing()) {
      <form class="gl-form" [formGroup]="form">
        <p class="gl-form__required-hint">
          Velden gemarkeerd met een sterretje
          (<span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span>) zijn verplicht.
        </p>

        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Boekingsdefinitie 
          </label>
          <div class="gl-field__control">
            <yds-text-field
              formControlName="bookingDefinitionName"
              [required]="true"
              [hasError]="isInvalid(form.get('bookingDefinitionName'))"
              [errorMsg]="'Boekingsdefinitie is verplicht.'"
              [placeholder]="'Voer een boekingsdefinitie in'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Boekingsgroep</label>
          <div class="gl-field__control">
            <p class="gl-field__readonly-text">{{ bookingGroupName() }}</p>
          </div>
        </div>

        <div class="gl-field gl-field--inline">
          <label class="gl-field__label">Actief</label>
          <div class="gl-field__control">
            <yds-switch formControlName="activeIndicator" />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Persoon selectie</label>
          <div class="gl-field__control">
            <yds-combobox
              formControlName="employmentSelectionId"
              [items]="employmentSelectionOptions()"
              [allowClear]="true"
              [placeholder]="'Selecteer een persoon selectie'"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">
           <span class="gl-form__required-hint-asterisk" aria-hidden="true">*</span> Begindatum 
          </label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="startDate"
              [required]="true"
              [locale]="translate.getCurrentLang()"
              [placeholder]="'dd-mm-jjjj'"
              [allowTodayAction]="false"
              [dateFilter]="firstDayOfMonthFilter"
              [errorMessage]="isInvalid(form.get('startDate')) ? 'Begindatum is verplicht.' : ''"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Einddatum</label>
          <div class="gl-field__control">
            <yds-date-picker
              formControlName="endDate"
              [locale]="translate.getCurrentLang()"
              [placeholderKey]="null"
              [placeholder]="''"
              [allowTodayAction]="false"
              [dateFilter]="lastDayOfMonthFilter"
              [errorMessage]="endDateError()"
            />
          </div>
        </div>

        <div class="gl-field">
          <label class="gl-field__label">Memo</label>
          <div class="gl-field__control">
            <yds-text-area
              formControlName="memoValue"
              [placeholder]="'Voer een memo in'"
              [maxLength]="500"
              [showCounter]="true"
            />
          </div>
        </div>
      </form>
    } @else {
      <div class="gl-detail">
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekingsdefinitie</span>
          <span class="gl-detail__value">{{ bookingDefinitionName() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Boekingsgroep</span>
          <span class="gl-detail__value">{{ bookingGroupName() }}</span>
        </div>
        <div class="gl-detail__row gl-detail__row--inline">
          <span class="gl-detail__label">Actief</span>
          <span class="gl-detail__value gl-detail__value--setting">
            @if (activeDisplay()) {
              <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
              <span>Ja</span>
            } @else {
              <span>Nee</span>
            }
          </span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Persoon selectie</span>
          <span class="gl-detail__value">{{ employmentSelectionDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Begindatum</span>
          <span class="gl-detail__value">{{ startDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Einddatum</span>
          <span class="gl-detail__value">{{ endDateDisplay() }}</span>
        </div>
        <div class="gl-detail__row">
          <span class="gl-detail__label">Memo</span>
          <span class="gl-detail__value gl-detail__value--memo">{{ memoDisplay() }}</span>
        </div>
      </div>
    }
  </yds-card-editable>

  @if (!isAddMode()) {
    <!-- Selectie criteria card (placeholder, hidden for now) -->
    <!-- <yds-card-editable class="bde-card" title="Selectie criteria">
      <p class="bde-empty">Nog niet beschikbaar.</p>
    </yds-card-editable> -->

    <!-- Uitvoercodes card -->
    <yds-card-editable
      class="bde-card"
      [title]="'Uitvoercodes - ' + bookingDefinitionName()"
      [(editing)]="outputCodesEditing"
      nextLabel="Opslaan"
      [nextDisabled]="isSavingOutputCodes()"
      (cancel)="onOutputCodesCancel()"
      (next)="onOutputCodesSave()"
    >
      @if (outputCodesEditing()) {
        <div class="gl-grid-wrapper">
          <table class="gl-grid gl-grid--excluded">
            <thead>
              <tr>
                <th class="gl-grid__col--criterium">Uitvoercode</th>
                <th class="gl-grid__col--action"></th>
              </tr>
            </thead>
            <tbody>
              @if (outputCodeRows().length === 0) {
                <tr class="gl-grid__empty">
                  <td colspan="2">Nog geen uitvoercode toegevoegd.</td>
                </tr>
              } @else {
                @for (row of outputCodeRows(); track $index) {
                  <tr>
                    <td class="gl-grid__col--criterium">
                      <yds-combobox
                        [items]="availableOutputCodeOptions($index)"
                        [ngModel]="row.elementId"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onOutputCodeElementChange($index, $event)"
                        [allowClear]="true"
                        [placeholder]="'Selecteer een uitvoercode'"
                      />
                    </td>
                    <td class="gl-grid__col--action">
                      <button
                        type="button"
                        class="gl-grid__remove"
                        aria-label="Verwijder uitvoercode"
                        (click)="removeOutputCodeRow($index)"
                      >
                        <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-delete" aria-hidden="true"></span>
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>

        <button type="button" class="gl-grid__add-link" (click)="addOutputCodeRow()">
          + Uitvoercode toevoegen
        </button>
      } @else {
        @if (outputCodeRows().length === 0) {
          <p class="bde-empty">Nog geen uitvoercode toegevoegd.</p>
        } @else {
          <div class="gl-grid-wrapper">
            <table class="gl-grid gl-grid--excluded">
              <thead>
                <tr>
                  <th class="gl-grid__col--criterium">Uitvoercode</th>
                  <th class="gl-grid__col--action"></th>
                </tr>
              </thead>
              <tbody>
                @for (row of outputCodeRows(); track $index) {
                  <tr>
                    <td class="gl-grid__col--criterium">{{ outputCodeRowLabel(row) }}</td>
                    <td class="gl-grid__col--action">
                      <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </yds-card-editable>

    <!-- Elementen card -->
    <yds-card-editable
      class="bde-card"
      [title]="'Elementen - ' + bookingDefinitionName()"
      [(editing)]="elementenEditing"
      nextLabel="Opslaan"
      [nextDisabled]="isSavingElementen()"
      (cancel)="onElementenCancel()"
      (next)="onElementenSave()"
    >
      @if (elementenEditing()) {
        <div class="gl-grid-wrapper">
          <table class="gl-grid gl-grid--excluded">
            <thead>
              <tr>
                <th class="gl-grid__col--criterium">Element</th>
                <th class="gl-grid__col--action"></th>
              </tr>
            </thead>
            <tbody>
              @if (elementRows().length === 0) {
                <tr class="gl-grid__empty">
                  <td colspan="2">Nog geen element toegevoegd.</td>
                </tr>
              } @else {
                @for (row of elementRows(); track $index) {
                  <tr>
                    <td class="gl-grid__col--criterium">
                      <yds-combobox
                        [items]="availableElementOptions($index)"
                        [ngModel]="row.elementId"
                        [ngModelOptions]="{ standalone: true }"
                        (ngModelChange)="onElementChange($index, $event)"
                        [allowClear]="true"
                        [placeholder]="'Selecteer een element'"
                      />
                    </td>
                    <td class="gl-grid__col--action">
                      <button
                        type="button"
                        class="gl-grid__remove"
                        aria-label="Verwijder element"
                        (click)="removeElementRow($index)"
                      >
                        <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-delete" aria-hidden="true"></span>
                      </button>
                    </td>
                  </tr>
                }
              }
            </tbody>
          </table>
        </div>

        <button type="button" class="gl-grid__add-link" (click)="addElementRow()">
          + Element toevoegen
        </button>
      } @else {
        @if (elementRows().length === 0) {
          <p class="bde-empty">Nog geen element toegevoegd.</p>
        } @else {
          <div class="gl-grid-wrapper">
            <table class="gl-grid gl-grid--excluded">
              <thead>
                <tr>
                  <th class="gl-grid__col--criterium">Element</th>
                  <th class="gl-grid__col--action"></th>
                </tr>
              </thead>
              <tbody>
                @for (row of elementRows(); track $index) {
                  <tr>
                    <td class="gl-grid__col--criterium">{{ elementRowLabel(row) }}</td>
                    <td class="gl-grid__col--action">
                      <span class="vismaicon vismaicon-dynamic vismaicon-sm vismaicon-checkmark" aria-hidden="true"></span>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      }
    </yds-card-editable>
  }
  }
</div>
